import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold my-2 text-fprimary" }, /*#__PURE__*/_toDisplayString('Medallero general'), -1)
const _hoisted_3 = { class: "d-flex my-2 align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.openModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + " + _toDisplayString(_ctx.t("add")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _ctx.getListMedals
        }, {
          default: _withCtx(() => [
            _createTextVNode("Actualizar")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.listMedals,
      border: "",
      "table-layout": 'auto',
      height: "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "business",
          label: "INSTITUCIÓN",
          width: "350",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "gold",
          label: "ORO",
          width: "80",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "silver",
          label: "PLATA",
          width: "80",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "bronze",
          label: "BRONCE",
          width: "80",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total",
          label: "TOTAL",
          width: "80",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "OP",
          width: "80",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: _normalizeClass(`badge badge-${scope.row.params}`)
            }, _toDisplayString(scope.row.status_name), 3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_AddEdit, {
      ref: "modalMedalRef",
      idevent: _ctx.id
    }, null, 8, ["idevent"])
  ], 64))
}